import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { getAllusuarios, getArea, getCargos, getRol, postuser } from '../../../redux/actions';
import {
  Container, TextField, Button, Grid, Paper, Typography, Modal, Box,
  IconButton, MenuItem, Select, FormControl, InputLabel, InputAdornment
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import CloseIcon from '@mui/icons-material/Close';
import { createSelector } from 'reselect';
import {
  FaUserPlus,
  FaUser,
  FaIdCard,
  FaEnvelope,
  FaBriefcase,
  FaSitemap,
  FaUserShield,
  FaSave,
  FaEye,
  FaSearch,
  FaUsers
} from 'react-icons/fa';
import styles from './Crearusuario.module.css';

const selectUsuarios = createSelector(
  (state) => state.allusuarios.usuarios,
  (usuarios) => usuarios || []
);

const selectCargos = createSelector(
  (state) => state.cargo || [],
  (cargos) => cargos.sort((a, b) => a.nombre.localeCompare(b.nombre))
);

const selectAreas = createSelector(
  (state) => state.area || [],
  (areas) => areas.sort((a, b) => a.descripcion.localeCompare(b.descripcion))
);

const selectRol = (state) => state.rol || [];

const FormularioUsuario = () => {
  const dispatch = useDispatch();
  const allusuarios = useSelector(selectUsuarios);
  const cargos = useSelector(selectCargos);
  const areas = useSelector(selectAreas);
  const roles = useSelector(selectRol);

  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [nombre, setNombre] = useState('');
  const [cedula, setCedula] = useState('');
  const [email, setEmail] = useState('');
  const [selectedCargo, setSelectedCargo] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedRol, setSelectedRol] = useState('');

  useEffect(() => {
    dispatch(getAllusuarios());
    dispatch(getCargos());
    dispatch(getArea());
    dispatch(getRol());
  }, [dispatch]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setSearchTerm('');
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!nombre || !cedula || !email || !selectedCargo || !selectedArea || !selectedRol) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: 'Por favor, completa todos los campos antes de guardar.',
        confirmButtonColor: '#3b82f6'
      });
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(email)) {
      Swal.fire({
        icon: 'warning',
        title: 'Email inválido',
        text: 'Por favor, ingresa un email válido.',
        confirmButtonColor: '#3b82f6'
      });
      return;
    }

    const newUser = {
      nombre,
      cedula,
      email,
      cargosid: selectedCargo,
      areaid: selectedArea,
      rolid: selectedRol,
    };

    dispatch(postuser(newUser))
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: '¡Usuario creado!',
          text: 'El colaborador ha sido registrado con éxito.',
          confirmButtonColor: '#10b981'
        });

        setNombre('');
        setCedula('');
        setEmail('');
        setSelectedCargo('');
        setSelectedArea('');
        setSelectedRol('');

        dispatch(getAllusuarios());
      });
  };

  const filteredUsuarios = allusuarios.filter((usuario) =>
    usuario.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
    usuario.cedula.includes(searchTerm)
  ).sort((a, b) => b.id - a.id);

  const columns = [
    { field: 'nombre', headerName: 'Nombre Completo', width: 220 },
    { field: 'cedula', headerName: 'Cédula', width: 130 },
    { field: 'email', headerName: 'Correo Electrónico', width: 220 },
    { field: 'cargo', headerName: 'Cargo', width: 180 },
    { field: 'area', headerName: 'Área', width: 150 },
    { field: 'rol', headerName: 'Rol', width: 90 },
  ];

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h2 className={styles.title}>
          <FaUserPlus /> Gestión de Usuarios
        </h2>
        <p className={styles.subtitle}>Registra y administra el personal de la organización en la plataforma.</p>
      </header>

      <Paper className={styles.formPaper}>
        <Typography className={styles.sectionTitle}>
          <FaUsers /> Perfil del Colaborador
        </Typography>

        <form onSubmit={handleSubmit} noValidate>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                className={styles.inputField}
                label="Nombre Completo"
                fullWidth
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><FaUser color="#94a3b8" /></InputAdornment>
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                className={styles.inputField}
                label="Cédula de Ciudadanía"
                fullWidth
                value={cedula}
                onChange={(e) => setCedula(e.target.value)}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><FaIdCard color="#94a3b8" /></InputAdornment>
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                className={styles.inputField}
                label="Correo Corporativo"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><FaEnvelope color="#94a3b8" /></InputAdornment>
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth className={styles.inputField}>
                <InputLabel>Cargo</InputLabel>
                <Select
                  value={selectedCargo}
                  onChange={(e) => setSelectedCargo(e.target.value)}
                  label="Cargo"
                  startAdornment={<InputAdornment position="start" style={{ marginRight: '8px' }}><FaBriefcase color="#94a3b8" /></InputAdornment>}
                >
                  {cargos.map((cargo) => (
                    <MenuItem key={cargo.id} value={cargo.id}>{cargo.nombre}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth className={styles.inputField}>
                <InputLabel>Área de Adscripción</InputLabel>
                <Select
                  value={selectedArea}
                  onChange={(e) => setSelectedArea(e.target.value)}
                  label="Área de Adscripción"
                  startAdornment={<InputAdornment position="start" style={{ marginRight: '8px' }}><FaSitemap color="#94a3b8" /></InputAdornment>}
                >
                  {areas.map((area) => (
                    <MenuItem key={area.id} value={area.id}>{area.descripcion}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth className={styles.inputField}>
                <InputLabel>Nivel de Acceso (Rol)</InputLabel>
                <Select
                  value={selectedRol}
                  onChange={(e) => setSelectedRol(e.target.value)}
                  label="Nivel de Acceso (Rol)"
                  startAdornment={<InputAdornment position="start" style={{ marginRight: '8px' }}><FaUserShield color="#94a3b8" /></InputAdornment>}
                >
                  {roles.map((rol) => (
                    <MenuItem key={rol.id} value={rol.id}>{rol.nombre}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
              <Button type="submit" variant="contained" className={styles.submitBtn} startIcon={<FaSave />}>
                Guardar Usuario
              </Button>
              <Button variant="outlined" className={styles.viewBtn} onClick={handleOpen} startIcon={<FaEye />}>
                Ver Directorio
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <Modal open={open} onClose={handleClose} closeAfterTransition>
        <Box className={styles.modalBox}>
          <div className={styles.modalHeader}>
            <Typography className={styles.modalTitle}>
              <FaUsers style={{ marginRight: '12px' }} /> Directorio de Usuarios
            </Typography>
            <IconButton onClick={handleClose} style={{ background: '#f1f5f9' }}>
              <CloseIcon />
            </IconButton>
          </div>

          <TextField
            placeholder="Buscar por nombre completo o cédula..."
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ marginBottom: '24px' }}
            InputProps={{
              startAdornment: <InputAdornment position="start"><FaSearch color="#3b82f6" /></InputAdornment>,
              style: { borderRadius: '16px', background: '#f1f5f9', border: 'none' }
            }}
          />

          <div className={styles.gridWrapper} style={{ height: 500 }}>
            <DataGrid
              rows={filteredUsuarios}
              columns={columns}
              localeText={esES.components.MuiDataGrid.defaultProps.localeText}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              pageSizeOptions={[10, 25, 50]}
              disableSelectionOnClick
              sx={{
                border: 'none',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#f8fafc',
                  color: '#475569',
                  fontWeight: '800',
                  borderBottom: '2px solid #e2e8f0'
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#eff6ff',
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: '1px solid #f1f5f9',
                  color: '#1e293b',
                  fontWeight: '500'
                }
              }}
            />
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default FormularioUsuario;
